import { Server, contentClient } from '@wajeez-web/core/api-base';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getMyCurrentProgresses: ApiMethod<
  Server.GetMyContentEntityProgressesInput & { typeName: string | undefined },
  { [key: string]: Server.ContentEntityProgressOutput[] }
> = async (data, { dispatch, rejectWithValue }) => {
  const { contentEntityIds, typeName } = data;

  const type = typeName ? typeName : 'all';

  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgresses_post_V1({
      contentEntityIds,
    });
    if (response.success && response.data) {
      return {
        [type]: response.data,
      };
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getMyCurrentStartedProgresses: ApiMethod<
  Server.GetMyContentEntityProgressesInput & { typeName: string | undefined },
  { [key: string]: Server.ContentEntityProgressOutput[] }
> = async (data, { dispatch, rejectWithValue }) => {
  const { contentEntityIds, typeName } = data;

  const type = typeName ? typeName : 'all';

  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgresses_post_V1({
      contentEntityIds,
    });
    if (response.success && response.data) {
      return {
        [type]: response.data,
      };
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getMyCurrentCompletedProgresses: ApiMethod<
  Server.GetMyContentEntityProgressesInput & { typeName: string | undefined },
  { [key: string]: Server.ContentEntityProgressOutput[] }
> = async (data, { dispatch, rejectWithValue }) => {
  const { contentEntityIds, typeName } = data;

  const type = typeName ? typeName : 'all';

  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgresses_post_V1({
      contentEntityIds,
    });
    if (response.success && response.data) {
      return {
        [type]: response.data,
      };
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getMyCurrentFollowedProgresses: ApiMethod<
  Server.GetMyContentEntityProgressesInput & { typeName: string | undefined },
  { [key: string]: Server.ContentEntityProgressOutput[] }
> = async (data, { dispatch, rejectWithValue }) => {
  const { contentEntityIds, typeName } = data;

  const type = typeName ? typeName : 'all';

  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgresses_post_V1({
      contentEntityIds,
    });
    if (response.success && response.data) {
      return {
        [type]: response.data,
      };
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getContinueListeningProgresses: ApiMethod<
  Server.GetMyContentEntityProgressesInput & { uniqueId: number },
  { [key: string]: Server.ContentEntityProgressOutput[] }
> = async (data, { dispatch, rejectWithValue }) => {
  const { contentEntityIds, uniqueId } = data;

  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgresses_post_V1({
      contentEntityIds,
    });
    if (response.success && response.data) {
      return {
        [uniqueId]: response.data,
      };
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const addSessionEvent: ApiMethod<
  Server.AddSessionEventInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_addEvent_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    // dispatch(
    //   CommonActions.setAlert({
    //     type: AlertType.WARNING,
    //     messages: JSON.parse(errors).errors || [
    //       { message: 'Something went wrong' },
    //     ],
    //   })
    // );

    return;
  }
};

export const getMyContentProgress: ApiMethod<
  Server.GetMyContentEntityProgressInput,
  Server.ContentEntityProgressOutput
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgress_post_V1(data);
    if (response.success && (response.data || response.data === null)) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getMyContentProgresses: ApiMethod<
  Server.GetMyContentEntityProgressesInput,
  Server.ContentEntityProgressOutput[]
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_myContentProgresses_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const markcontentAsCompleted: ApiMethod<
  Server.MarkContentEntityAsCompletedInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Sessions_Client(undefined, contentClient);
    const response = await client.sessions_markCompleted_post_V1(data);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};
